import React, { useCallback, useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Thumbnail from '../assets/images/folder.svg'
import { withWindowSizeListener } from 'react-window-size-listener'

import { imageBaseURL } from '../services/defaultProps'
import 'react-lazy-load-image-component/src/effects/blur.css'

import '../styles/components/CategoryGrid.css'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const CategoryGrid = ({ windowSize: { windowWidth }, ...props }) => {
  const history = useHistory()

  const { startOpeningCategory } = props

  const renderCategoriesGrid = useCallback(() => {
    const [itemWidth, setItemWidth] = useState(0)
    const itemRef = useRef(null)

    /*
      listen the window width, when the window width changes, update
      the item width to calculate the new height based on the new width

      obs: similar to aspect-ratio property
    */
    useEffect(() => {
      setItemWidth(itemRef.current.offsetWidth)
    }, [windowWidth])

    const categories = props.categories.map((item, index) => {
      const thumbnail = item.closetImages.length > 0 ? imageBaseURL + item.closetImages[0].image : Thumbnail
      return (
        <div key={item.id} className='categorygrid-item'
          style={{ height: 4 * itemWidth / 3 }} ref={itemRef}
          onClick={() => { history.push('/closet/grid', { photos: props.categories[index].closetImages, title: item.name }) }}>
          <div className='categorygrid-item-image-container'>
            <LazyLoadImage src={thumbnail} effect='blur'
              width='100%'
              height='100%'
              style={{
                objectFit: 'cover',
                objectPosition: 'center'
              }} />
          </div>
          <div className='categorygrid-item-desc'>
            <span>{item.name}</span>
          </div>
        </div>
      )
    })

    return categories
  }, [props.categories, history, windowWidth])

  if (startOpeningCategory !== null) {
    history.replace('/closet/grid', { photos: props.categories[startOpeningCategory].closetImages, title: props.categories[startOpeningCategory].name })
    return <div />
  }

  return (
    <div className='categorygrid-items'>
      {renderCategoriesGrid()}
    </div>
  )
}

CategoryGrid.propTypes = {
  categories: PropTypes.array.isRequired,
  startOpeningCategory: PropTypes.number
}

CategoryGrid.defaultProps = {
  startOpeningCategory: null
}

export default withWindowSizeListener(CategoryGrid)



// WEBPACK FOOTER //
// ./src/components/CategoryGrid.js